import { Route } from 'react-router-dom';
import BackofficeTemplate from './BackofficeTemplate/BackofficeTemplate';

export const endpointMacra1 = {
    //Backoffice Macra1
    macra1BackofficeTemplate: '/backoffice/channel-and-banks-protection/template',
    macra1BackofficeTemplateWithId: '/backoffice/channel-and-banks-protection/template/:id',
};

export type TEndpointMacra1 = keyof typeof endpointMacra1;

const routeMacra1 = () => (
    <>
        <Route path={endpointMacra1.macra1BackofficeTemplate} element={<BackofficeTemplate />} />
        <Route path={endpointMacra1.macra1BackofficeTemplateWithId} element={<BackofficeTemplate />} />
    </>
);

export default routeMacra1();
